Librarian.CustomDownloadWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["submit"],

    options: {
        id: "CustomDownloadWindow",
        height: 340,
        width: 430,
        pageName: null,
        titleName: null,
        formData: null
    },

    onSubmit: null,
    onLoad: null,
    onConfirm: null,

    initialize: function(options) {
        this.setOptions(options);

        this.onSubmit = options.onSubmit;
        this.onLoad = options.onLoad;
        this.onConfirm = options.onConfirm;

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString(this.options.titleName);

        this.options.contentURL = Librarian.path.getLibraryPath() + this.options.pageName;

        this.parent(this.options);
    },

    onWindowLoaded: function() {
        this.parent();

        var itemEl = $("downloadCancel");
        if (itemEl) {
            itemEl.id = this.options.id + '_' + itemEl.id;
            itemEl.addOnClick(this.close, this);
        }

        itemEl = $("downloadSubmit");
        if (itemEl) {
            itemEl.id = this.options.id + '_' + itemEl.id;
            itemEl.addOnClick(this.submit, this);
        }

        itemEl = $("downloadForm");
        if (itemEl)
            itemEl.id = this.options.id + '_' + itemEl.id;

        itemEl = $("downloadFormSize");
        if (itemEl) {
            itemEl.id = this.options.id + '_' + itemEl.id;

            if (itemEl.width)
                this.options.width = itemEl.width.value.toInt();
            if (itemEl.height)
                this.options.height = itemEl.height.value.toInt();

            // Then resize the window
            this.resize({
                width: this.options.width,
                height: this.options.height,
                centered: false
            });
        }

        if (typeof this.onLoad == "function")
            this.onLoad.bind(this)();
    },

    submit: function() {
        if (typeof this.onSubmit == "function") {
            if (this.onSubmit())
                this.close();
        }
        else
            this.close();
    }
});
